<script>
    export let isLoading = false;
    export let isIzziLogo = true;

    let logo = isIzziLogo
        ? '/assets/img/logos/izzi-logo.svg'
        : '/assets/img/logos/sky-logo.svg';
</script>

{#if isLoading}
    <div class="loader-container">
        <div class="loader">
            <img src={logo} alt="" />
            <p class="fw-bold m-t-25 padding-center">
                Estamos preparando algo para ti.<br class="hide-for-mobile" />
                Por favor, aguarda un momento
                <span class="loader-dot">
                    <span />
                    <span />
                    <span />
                </span>
            </p>
        </div>
    </div>
{/if}
